import * as React from 'react';


import Search from './elastic/Search';
import withMainNavigation from './withMainNavigation';

interface IProps {
    documentHandlerActionButtons?: any;
}

class SearchContainer extends React.Component<IProps> {
    public render() {
        return <Search />;
    }
}

export default withMainNavigation(SearchContainer);
